import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { toast } from "sonner";

/**
 * Hook to create a new expense.
 * Invalidates the expense queries on success.
 */
export function useCreateExpense() {
  const trpc = useTRPC();

  const mutation = useMutation({
    ...trpc.expense.createExpense.mutationOptions(),
    onError: (error) => {
      toast.error(error.message || "Failed to submit expense");
    },
  });

  return mutation;
}
